import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Switch } from "react-router";

import { inquirySearchOrderUrl } from "./urls";
import Orders from "./views/Orders";

const Inquiry = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.inquiry)} />
      <Switch>
        <Route exact path={inquirySearchOrderUrl} component={Orders} />
      </Switch>
    </>
  );
};

export default Inquiry;
